var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Icons from '../../../icons/index';
import { CenterContainer } from '../../../styles/generalStyles';
import LangMessage from '../lang/message';
import { Button } from './button.styles';
var BackButton = function (_a) {
    var onClick = _a.onClick;
    var arrow = Icons.arrow;
    return (_jsx(Button, __assign({ "$size": 'extraSmall', "$bgColour": 'red', onClick: onClick }, { children: _jsxs(CenterContainer, { children: [_jsx("img", { alt: 'arrow', src: arrow }), _jsx(LangMessage, { msgKey: 'button.back ' })] }) })));
};
export default BackButton;
